import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TextMaskModule } from 'angular2-text-mask';
import { DialogResult } from '../material-design/DialogResult.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../../app.module';
import { HttpClient } from '@angular/common/http';
import { MaterialModule } from '../material-design/mat-modules';
import { NgBoostrapModule } from '../../shared/ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ArchwizardModule } from 'ng2-archwizard';
import { NgxEditorModule } from 'ngx-editor';
import { ModalComponent } from '../modal/modal.component';
import { EqualValidator } from '../../utils/equal-validator.directive';
import { CarrousselAccountComponent } from '../../component/account/carroussel-account/carroussel-account.component';
import { AdvancedSearchModule } from '../advanced-search/advanced-search.module';
import { CommentPanelComponent } from '../../shared/comment-panel/comment-panel.component';
import { ChatPanelComponent } from '../../shared/chat-panel/chat-panel.component';
import { AdvancedSearchComponent } from '../advanced-search/advanced-search.component';
import { CollapsiblePanelComponent } from '../collapsible-panel/collapsible-panel.component';
import { ChatService } from '../../services/chat.service';
import { AdvancedFormSearchComponent } from '../advanced-form-search/advanced-form-search.component';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { FavoriComponent } from '../favori/favori.component';
import { FavoriService } from '../../services/favori.service';
import { DatetimePickerComponent } from '../datetime-picker/datetime-picker.component';
import { NgUploaderModule } from 'ngx-uploader';
import { DocumentsComponent } from '../documents/documents.component';
import { PopUpDetailsDemandeComponent } from '../pop-up-details-demande/pop-up-details-demande.component';
import { FormAdresseComponent } from '../../shared/adresses/form-adresse/form-adresse.component';
import { CotationComponent } from '../../component/pricing-booking/shared-component/cotation/cotation.component';
import { ModalEventComponent } from '../../component/track-trace/shared-components/modal-event/modal-event.component';
import { Ng2CompleterModule } from "ng2-completer"
// import { TagInputModule } from 'ngx-chips';

@NgModule({
	imports: [
		NgSelectModule,
		CommonModule,
		NgxEditorModule,
		FormsModule,
		MaterialModule,
		NgBoostrapModule,
		RouterModule,
		TextMaskModule,
		ReactiveFormsModule,
		TranslateModule,
		NgbModule,
		NgBoostrapModule,
		ArchwizardModule,
		   NgUploaderModule,
		   Ng2CompleterModule
    // TagInputModule
	],
	declarations: [
		ModalComponent,
		DialogResult,
		EqualValidator,
		CarrousselAccountComponent,
		ChatPanelComponent,
		CommentPanelComponent,
		AdvancedSearchComponent,
		CollapsiblePanelComponent,
		AdvancedFormSearchComponent,
		AutocompleteComponent,
		FavoriComponent,
		DatetimePickerComponent,
		DocumentsComponent,
		PopUpDetailsDemandeComponent,
		FormAdresseComponent,
		CotationComponent,
		ModalEventComponent,

	],
	exports: [
		NgSelectModule,
		CommonModule,
		NgxEditorModule,
		FormsModule,
		MaterialModule,
		NgBoostrapModule,
		RouterModule,
		TextMaskModule,
		ReactiveFormsModule,
		DialogResult,
		TranslateModule,
		NgbModule,
		NgBoostrapModule,
		ArchwizardModule,
		ModalComponent,
		EqualValidator,
		CarrousselAccountComponent,
		ChatPanelComponent,
		CommentPanelComponent,
		AdvancedSearchComponent,
		CollapsiblePanelComponent,
		AdvancedFormSearchComponent,
		AutocompleteComponent,
		FavoriComponent,
		DatetimePickerComponent,
		DocumentsComponent,
		PopUpDetailsDemandeComponent,
		FormAdresseComponent,
		CotationComponent,
		ModalEventComponent,
	],
	entryComponents: [
		DialogResult,
		ModalComponent
	],
	providers: [
		ChatService,
	]

})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/module/shared.module.ts